import React from "react";
import "./fancy-radio-group.scss";

/**
 * FancyRadioGroup
 *
 * Props:
 * - name (string): group name for radios
 * - options (array): [{ value: 'LOW', label: 'Low' }, ...]
 * - value (string): currently selected value
 * - onChange (fn): callback when selection changes
 * - direction (row|column): layout direction (default: row)
 */
export default function FancyRadioGroup({
  name,
  options,
  value,
  onChange,
  direction = "row",
}) {
  return (
    <div className="fancy-radio-group" data-dir={direction}>
      <div className="radio-list" role="radiogroup" aria-label={name}>
        {options.map((opt) => {
          const checked = String(opt.value) === String(value);
          return (
            <label
              key={opt.value}
              className={`radio-label ${checked ? "checked" : ""}`}
            >
              <input
                className="input"
                type="radio"
                name={name}
                value={opt.value}
                checked={checked}
                onChange={() => onChange(opt.value)}
              />
              <span className="label-text">{opt.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
}
